export const STATE_WORD = {
  healthy: { word: "Healthy", tone: "green" },
  broken: { word: "Broken", tone: "red" },
  alert: { word: "Alert fired", tone: "amber" },
  waiting: { word: "Waiting on you", tone: "amber" },
  stale: { word: "Stale", tone: "amber" },
  empty: { word: "Quiet", tone: "muted" },
};
